import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import GoogleLogin from "../../components/LoginProvider/GoogleLogin";
import { AuthContext } from "../../contexts/AuthProvider";
import toast from "react-hot-toast";
import useToken from "../../hooks/useToken";

const Login = () => {
  const { logIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [loginUserEmail, setLoginUserEmail] = useState("");
  const [token] = useToken(loginUserEmail);

  // after login success and got jwt token redirect to previous route
  const from = location.state?.from?.pathname || "/";
  if (token) {
    navigate(from, { replace: true });
  }

  // React Hooks Form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    logIn(data.email, data.password)
      .then((result) => {
        const user = result.user;
        setLoginUserEmail(data.email);
        toast.success("Login success");
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="min-w-[380px] p-7 shadow">
        <h2 className="text-xl font-medium my-5">LOGIN</h2>
        <form onSubmit={handleSubmit(onSubmit)} className="grid gap-4">
          <div className="form-control w-full ">
            <input
              type="email"
              placeholder="Email"
              className="input input-bordered w-full max-w-xs"
              {...register("email", { required: "Email is required" })}
            />
            {errors.email && (
              <p role="alert" className="mt-2 text-red-800 text-sm ml-1">
                {errors.email?.message}
              </p>
            )}
          </div>
          <div className="form-control w-full ">
            <input
              type="password"
              placeholder="Password"
              className="input input-bordered w-full max-w-xs"
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 6,
                  message: "Password must be 6 characters or longer",
                },
              })}
            />
            {errors.password && (
              <p role="alert" className="mt-2 text-red-800 text-sm ml-1">
                {errors.password?.message}
              </p>
            )}
          </div>
          <p className="text-xs my-1">Forgot password? </p>
          <input type="submit" value="Login" className="btn w-full my-2" />
        </form>
        <p className="text-sm my-2">
          New to Doctor's Portal ?{" "}
          <Link to="/register" className="text-secondary font-medium ">
            SignUp
          </Link>
        </p>
        <div className="divider">OR</div>
        <GoogleLogin />
      </div>
    </div>
  );
};

export default Login;
